/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import $ from "jquery";

$(document).ready(function() {
    var audioElement = document.createElement('audio');
    audioElement.setAttribute('src', '/assets/sound/hoerprobe_zeltinger.mp3');
    /* 
    audioElement.addEventListener('ended', function() {
        this.play();
    }, false);
    */
    $('#hoerprobe_button').on('click',function(e) {
        e.preventDefault();
        if(audioElement.duration == 0 || audioElement.paused) {
            audioElement.play();
        } else {
            audioElement.pause();
        }
    });
});
